import { render, staticRenderFns } from "./ShopCartExpanded.vue?vue&type=template&id=71d12e82&scoped=true&"
import script from "./ShopCartExpanded.vue?vue&type=script&lang=js&"
export * from "./ShopCartExpanded.vue?vue&type=script&lang=js&"
import style0 from "./ShopCartExpanded.vue?vue&type=style&index=0&id=71d12e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d12e82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
